import script from "./HomeFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeFooter.vue?vue&type=script&setup=true&lang=js"

import "./HomeFooter.vue?vue&type=style&index=0&id=09ee3b69&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ee3b69"]])

export default __exports__